import '../styles/login.css';
import { useState } from 'react';
import { useEffect } from 'react';
import LoginForm from '../components/loginForm';
import bettercomLogo from '../assets/bettercom-logo.png';

const LoginPage = () => {
  const [supportMessage, setSupportMessage] = useState(""); 

  useEffect(() => {
    document.title = "Galileo Analytics - Login";
  }, []);

  const handleForgotPassword = () => {
    setSupportMessage(
      <>
        Indíquele al Administrador de Sistemas que necesita{" "}
        <span className="support-text-span">recuperar o cambiar su clave de acceso</span>.
      </>
    );  
  };

  const handleNoAccount = () => {
    setSupportMessage(
      <>
        Indíquele al Administrador de Sistemas que necesita{" "}
        <span className="support-text-span">una cuenta para acceder a este sistema</span>.
      </>
    );
  };

  return (
    <>
      <div className="bettercom-logo-container">
        <img 
          className="bettercom-logo"
          src={bettercomLogo}
          alt="Bettercom Login Logo"
        />
      </div> 

      <div className="login-container">
        <h2 className="form-title">¡Bienvenido!</h2>
        <p className="separator"><span>-</span></p>

        <LoginForm setSupportMessage={setSupportMessage} />

        <a className="forgot-password-link" onClick={handleForgotPassword}>
          ¿Olvidó su clave?
        </a>

        <p className="signup-prompt">
          ¿No tiene una cuenta?{" "}
          <a className="get-password-link" onClick={handleNoAccount}>
            ¡Consiga una!
          </a>
        </p>

        {supportMessage && (
          <div className="support-view">
            <div className="support-message">
              <div className="close-view" onClick={() => setSupportMessage("")}>
                <a>X</a>
              </div>
              <span><strong>{supportMessage}</strong></span>
              <br />
              <div className="number-span">
                <span>
                  <strong>📞Soporte Técnico:</strong>
                  <p>+54 3755-788989</p>
                  <p>+54 3755-220820</p>
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
      
      <div className='login-footer'>
        <span>
          Copyright 2025 Bettercom S.A.S - Todos los derechos reservados
        </span>
      </div>


    </>
  );
};

export default LoginPage;
